
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/refund-conditions",
      function () {
        return require("private-next-pages/content/refund-conditions.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/refund-conditions"])
      });
    }
  